import { render, staticRenderFns } from "./ChevronUpSolid.vue?vue&type=template&id=8a8e91b8"
import script from "./ChevronUpSolid.vue?vue&type=script&lang=ts"
export * from "./ChevronUpSolid.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports